import { Box } from "../Box";
import { Button } from "../Button";
import { Link } from "../Link";
import { jsx, jsxs } from "react/jsx-runtime";
const AccountFormControls = ({
  analyticsName,
  loading,
  onRequestPasswordlessLogin: _onRequestPasswordlessLogin,
  isRequestingPasswordlessLogin,
  disabled,
  actionText = "Confirm",
  showForgotPassword = !0,
  openForgotPasswordInNewTab,
  forgotPasswordText = "Forgot password?",
  forgotPasswordAriaNewWindow = "Forgot password? Opens in a new window",
  forgotPasswordAriaSameWindow = "Forgot password?",
  submitA11yProps
}) => /* @__PURE__ */ jsxs(Box, { gap: "$20x", children: [
  /* @__PURE__ */ jsx(
    Button,
    {
      testID: "account-form-submit-button",
      variant: "primary",
      type: "submit",
      label: actionText,
      size: "medium",
      analyticsName: `${analyticsName}-account-form-control-action-button`,
      width: "100%",
      loading: loading && !isRequestingPasswordlessLogin,
      disabled,
      ...submitA11yProps
    }
  ),
  showForgotPassword && /* @__PURE__ */ jsx(
    Link,
    {
      variant: "primary",
      href: "/reset-password",
      analyticsName: `${analyticsName}-forgot-password`,
      target: openForgotPasswordInNewTab ? "_blank" : "_self",
      "aria-label": openForgotPasswordInNewTab ? forgotPasswordAriaNewWindow : forgotPasswordAriaSameWindow,
      margin: "auto",
      children: forgotPasswordText
    }
  )
] });
export {
  AccountFormControls
};
